exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.linked-card::after {\n  width: 1px;\n  content: ' ';\n  border: 1px solid #e5e5e5;\n  height: 17px;\n  top: 100%;\n  position: absolute;\n  left: 32px;\n}\n", ""]);

// exports
